import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { BranchService } from '@core/services/branch.service';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { OnboardingGuard } from '@core/guard/onboarding.guard';
import { LeaveWorkSpaceGuard } from '@modules/organisation-workspaces/guard/workspace.guard';
import { dataResolver } from '@modules/organisation-workspaces/organisation-workspaces-resolver';

const routes: Routes = [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthenticatedGuard, OnboardingGuard]
      },
      {
        path: 'onboarding',
        loadChildren: () => import('./modules/onboarding/onboarding.module').then(m => m.OnboardingModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'settings',
        loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'organisations',
        loadChildren: () => import('@modules/organisations/organisations.module').then(m => m.OrganisationsModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'courses',
        loadChildren: () => import('@modules/courses/courses.module').then(m => m.CoursesModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        // Not on a vanity domain: the provider's own catalogue is linked in the menu there.
        path: 'catalog',
        loadChildren: () => import('@modules/catalog/catalog.module').then(m => m.CatalogModule),
        canActivate: [AuthenticatedGuard, () => !inject(BranchService).vanityMode || inject(Router).parseUrl('/dashboard')]
      },
      {
        path: 'order',
        loadChildren: () => import('@modules/order/order.module').then(m => m.OrderModule),
      },
      {
        path: 'login',
        loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'connect',
        loadChildren: () => import('@modules/connect/connect.module').then(m => m.ConnectModule)
      },
      { path: 'enrolments',
        loadChildren: () => import('./modules/enrolments/enrolments.module').then(m => m.EnrolmentsModule),
        canActivate: [AuthenticatedGuard] },
      {
        path: 'files',
        loadChildren: () => import('./modules/certificates/certificates.module').then(m => m.CertificatesModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'knowledge',
        loadChildren: () => import('./modules/knowledge/knowledge.module').then(m => m.KnowledgeModule),
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'saml',
        loadChildren: () => import('./modules/saml/saml.module').then(m => m.SamlModule)
      },
      {
        path: 'legal',
        loadChildren: () => import('./modules/legal/legal.module').then(m => m.LegalModule)
      },
      {
        path: 'qhse',
        loadChildren: () => import('./modules/qhse/qhse.module').then(m => m.QhseModule)
      },
      {
        path: 'evaluation-forms',
        loadChildren: () => import('./modules/evaluation-forms/evaluation-forms.module').then(m => m.EvaluationFormsModule)
      },
      {
        path: 'forms',
        loadChildren: () => import('./modules/course-forms/course-forms.module').then(m => m.CourseFormsModule),
        data: { hideMenu: true }
      },
      {
        path: 'communication',
        loadChildren: () => import('./modules/communication/communication.module').then(m => m.CommunicationModule)
      },
      {
        path: 'ows/:id',
        loadChildren: () => import('./modules/organisation-workspaces/organisation-workspaces.module').then(m => m.OrganisationWorkspacesModule),
        canDeactivate:[LeaveWorkSpaceGuard]
      },
      {
        path: 'cv',
        loadChildren: () => import('./modules/cv/cv.module').then(m => m.CvModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full'},

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules, anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
